import Vue from "vue";
import Router from "vue-router";
import store from "../store/index";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/index"
    },
    {
      path: "/index",
      component: () => import("@/views/index/index"),
      meta: {
        title: "首页",
        // 缓存首页
        keepAlive: true
      }
    },{
      path: "/notice",
      name:'notice',
      component: () => import("@/views/index/notice"),
      meta: {
        title: "通知公告",
        // 缓存首页
        keepAlive: false
      }
    },
    {
      path: "/seat",
      name:'seat',
      component: () => import("@/views/seat/index"),
      meta: {
        title: "座位预约",
        // 缓存首页
        keepAlive: false
      }
    },{
      path: "/sroom",
      name:'sroom',
      component: () => import("@/views/sroom/index"),
      meta: {
        title: "研修室预约",
        // 缓存首页
        keepAlive: false
      }
    },{
      path: "/cgyy",
      name:'cgyy',
      component: () => import("@/views/cgyy/index"),
      meta: {
        title: "场馆预约",
        // 缓存首页
        keepAlive: false
      }
    },
    {
      path: "/my",
      name:'my',
      component: () => import("@/views/my/index"),
      redirect: "/my/center",
      children: [
        {
          path: "center",
          meta: {
            title: "个人中心"
          },
          component: () => import("@/views/my/children/center")
        },
        {
          path: "set",
          meta: {
            title: "设置"
          },
          component: () => import("@/views/my/children/set")
        },
        {
          path: "mySeat",
          meta: {
            title: "我的座位"
          },
          component: () => import("@/views/my/children/mySeat")
        },
        {
          path: "mySroom",
          meta: {
            title: "我的研修室"
          },
          component: () => import("@/views/my/children/mySroom")
        },
		{
		  path: "myCg",
		  meta: {
		    title: "我的场馆"
		  },
		  component: () => import("@/views/my/children/myCg")
		},
		{
		  path: "suggest",
		  meta: {
		    title: "咨询建议"
		  },
		  component: () => import("@/views/my/children/suggest")
		},
		{
		  path: "suggestAdd",
		  meta: {
		    title: "咨询建议"
		  },
		  component: () => import("@/views/my/children/suggestAdd")
		},
        {
          path: "updatPwd",
          meta: {
            title: "修改密码"
          },
          component: () => import("@/views/my/children/set")
        }
      ]
    },
    {
      path: "/login",
      component: () => import("@/views/login/index"),
      meta: {
        title: "登陆"
      }
    },
    {
      path: "*",
      component: () => import("@/components/NotFound")
    }
  ]
});

router.beforeEach((to, from, next) => {
  let { title, needLogin } = to.meta;
  let { isLogin } = store.state;
  document.title = title;

  if (needLogin && !isLogin) {
    next({
      path: "/login"
    });
  } else {
    next();
  }
});

export default router;
